export const MAX_BINDING_PARAMS = 65536;
